import React from "react";

export default function TranslationModal({
  tx,
  translationModalOpen,
  setTranslationModalOpen,
  buttonStyle,
  fieldStyle,
  labelStyle,
  inputStyle,
  translationSourceText,
  translationLoading,
  translationInputs,
  setTranslationInputs,
  translationError,
  translationSaving,
  saveTranslationModal,
}) {
  if (!translationModalOpen) return null;

  return (
    <div
      role="dialog"
      aria-modal="true"
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(4,8,18,0.7)",
        backdropFilter: "blur(4px)",
        zIndex: 2200,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 16,
      }}
    >
      <div
        style={{
          width: "100%",
          maxWidth: 620,
          borderRadius: 16,
          border: "1px solid rgba(255,255,255,0.12)",
          background: "rgba(12,15,22,0.95)",
          boxShadow: "0 16px 48px rgba(0,0,0,0.45)",
          padding: 16,
          display: "flex",
          flexDirection: "column",
          gap: 12,
        }}
      >
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <div style={{ color: "#fff", fontWeight: 800 }}>
            {tx("Name Translations", "Namensübersetzungen", "名称翻译")}
          </div>
          <button
            type="button"
            onClick={() => setTranslationModalOpen(false)}
            style={{ ...buttonStyle, background: "rgba(255,255,255,0.14)", color: "#fff", padding: "6px 10px" }}
          >
            {tx("Close", "Schließen", "关闭")}
          </button>
        </div>

        <div style={fieldStyle}>
          <label style={labelStyle}>🇩🇪 {tx("German source", "Deutsche Quelle", "德语原文")}</label>
          <input type="text" value={translationSourceText || ""} readOnly style={{ ...inputStyle, opacity: 0.95 }} />
        </div>

        {translationLoading ? (
          <div style={{ color: "#cfe4ff", fontSize: 12 }}>{tx("Loading…", "Laden…", "加载中…")}</div>
        ) : (
          <>
            <div style={fieldStyle}>
              <label style={labelStyle}>🇬🇧 English</label>
              <input
                type="text"
                value={translationInputs.en}
                onChange={(e) => setTranslationInputs((prev) => ({ ...prev, en: e.target.value }))}
                style={inputStyle}
                placeholder={tx("Enter English name", "Englischen Namen eingeben", "输入英文名称")}
              />
            </div>
            <div style={fieldStyle}>
              <label style={labelStyle}>🇨🇳 中文</label>
              <input
                type="text"
                value={translationInputs.zh}
                onChange={(e) => setTranslationInputs((prev) => ({ ...prev, zh: e.target.value }))}
                style={inputStyle}
                placeholder={tx("Enter Chinese name", "Chinesischen Namen eingeben", "输入中文名称")}
              />
            </div>
          </>
        )}

        {translationError && <div style={{ color: "#ffb3b3", fontSize: 12 }}>{translationError}</div>}

        <div style={{ display: "flex", justifyContent: "flex-end", gap: 8 }}>
          <button
            type="button"
            onClick={() => setTranslationModalOpen(false)}
            style={{ ...buttonStyle, background: "rgba(255,255,255,0.14)", color: "#fff", padding: "8px 12px" }}
            disabled={translationSaving}
          >
            {tx("Cancel", "Abbrechen", "取消")}
          </button>
          <button
            type="button"
            onClick={saveTranslationModal}
            style={{ ...buttonStyle, padding: "8px 12px" }}
            disabled={translationSaving || translationLoading}
          >
            {translationSaving ? tx("Saving…", "Speichern…", "保存中…") : tx("Save", "Speichern", "保存")}
          </button>
        </div>
      </div>
    </div>
  );
}
